import React, { useRef, useState } from "react";
import {
    I2cIcon,
    I2cRadioGroup,
    I2cRadioButton,
    I2cPhoneField,
    I2cTextarea,
    I2cInput, I2cButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../../Components/SharedComponent/ErrorMessage/ErrorMessage";

import { useForm, useFieldArray } from "react-hook-form";

const ContactUsCommon = ({ control, handleValueChanges, methods, errors }) => {
    const { fields: fieldArray, append } = useFieldArray({
        control,
        name: "brand_info_common_brand_contact_us_custom",
    });
    const handleAddAnother = () => {
        append({
            page_name: "",
            page_link: "",
        });
    };
    const clearFields = (fields) => {
        fields.forEach((field) => methods.setValue(field, ""));
    };
    return (
        <>
            <div i2c-grid="12">
                <div className="single-field-wrapper">
                    <Controller
                        name="brand_info_common_brand_contact_us_feature_type"
                        control={control}
                        render={({ field }) => (
                            <I2cRadioGroup
                                // label="Please specify the brand colors you want to use."
                                {...field}
                                name="brand_info_common_brand_contact_us_feature_type"
                                onI2cChange={(e) => {
                                    field.onChange(e);
                                    if (e.target.value === "Use i2c Standard Feature") {  
                                        methods.setValue("brand_info_common_brand_contact_us_custom", [
                                            { page_name: "", page_link: "" },
                                          ]);
                                    }
                                    else {
                                        clearFields([
                                            "brand_info_common_brand_contact_us_i2c_standard_email",
                                            "brand_info_common_brand_contact_us_i2c_standard_customer_call_phone",
                                            "brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone",
                                            "brand_info_common_brand_contact_us_i2c_standard_working_hours",
                                            "brand_info_common_brand_contact_us_i2c_standard_head_office_address",
                                            "brand_info_common_brand_contact_us_i2c_standard_postal_address",
                                            "brand_info_common_brand_contact_us_i2c_standard_facebook_link",
                                            "brand_info_common_brand_contact_us_i2c_standard_instagram_link",
                                            "brand_info_common_brand_contact_us_i2c_standard_twitter_link",
                                            "brand_info_common_brand_contact_us_i2c_standard_youtube_link",
                                            "brand_info_common_brand_contact_us_i2c_standard_linkedin_link",
                                        ]);
                                    }
                                    methods.trigger();
                                    handleValueChanges();
                                }}
                            >
                                {["Use i2c Standard Feature", "Use External URL"].map((cBC, index) => (
                                    <I2cRadioButton
                                        key={index}
                                        checked={
                                            methods.watch("brand_info_common_brand_contact_us_feature_type") === cBC
                                        }
                                        value={cBC}
                                    >
                                        {cBC}
                                    </I2cRadioButton>
                                ))}
                            </I2cRadioGroup>
                        )}
                    />
                    <ErrorMessage
                        show={
                            errors.brand_info_common_brand_contact_us_feature_type &&
                                methods.formState.touchedFields.brand_info_common_brand_contact_us_feature_type
                                ? true
                                : false
                        }
                        message={errors.brand_info_common_brand_contact_us_feature_type?.message ?? "Invalid input"}
                    />
                </div>
            </div>
            {
                methods.watch("brand_info_common_brand_contact_us_feature_type") === "Use i2c Standard Feature" && (
                    <div i2c-grid="12" >
                        <div i2c-grid="grid gap-sm">
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_email"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="Email Address"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_contact_us_i2c_standard_email"}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        Email address to receive customer queries
                                                        <sup>•</sup>
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <I2cPhoneField
                                        // format="NATIONAL"
                                        name="brand_info_common_brand_contact_us_i2c_standard_customer_call_phone"
                                        label="Phone numbers to receive customer calls"
                                        size="large"
                                        country-box
                                        onI2cInput={(e) => {
                                            const country = e.target.country;
                                            const isValid = e.target.isValid;
                                            const value = e.target.value;
                                            methods.setValue(
                                                "brand_info_common_brand_contact_us_i2c_standard_customer_call_phone_country",
                                                country,
                                            );
                                            methods.setValue(
                                                "brand_info_common_brand_contact_us_i2c_standard_customer_call_phone",
                                                value,
                                            );
                                            methods.trigger();
                                            handleValueChanges();
                                            if (!isValid) {
                                                methods.setError("brand_info_common_brand_contact_us_i2c_standard_customer_call_phone", {
                                                    message: e.target.guide,
                                                });
                                            } else {
                                                methods.clearErrors(
                                                    "brand_info_common_brand_contact_us_i2c_standard_customer_call_phone",
                                                );
                                            }
                                        }}
                                        required
                                        selectedCountry={
                                            methods.watch(
                                                "brand_info_common_brand_contact_us_i2c_standard_customer_call_phone_country",
                                            ) ?? "US"
                                        }
                                        placeholder="1 (212) 313-2123"
                                        value={methods.watch("brand_info_common_brand_contact_us_i2c_standard_customer_call_phone")}
                                    />

                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <I2cPhoneField
                                        // format="NATIONAL"
                                        name="brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone"
                                        label="Phone numbers to receive cardholder enrollment requests"
                                        size="large"
                                        country-box
                                        onI2cInput={(e) => {
                                            const country = e.target.country;
                                            const isValid = e.target.isValid;
                                            const value = e.target.value;
                                            methods.setValue(
                                                "brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone_country",
                                                country,
                                            );
                                            methods.setValue(
                                                "brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone",
                                                value,
                                            );
                                            methods.trigger();
                                            handleValueChanges();
                                            if (!isValid) {
                                                methods.setError("brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone", {
                                                    message: e.target.guide,
                                                });
                                            } else {
                                                methods.clearErrors(
                                                    "brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone",
                                                );
                                            }
                                        }}
                                        required
                                        selectedCountry={
                                            methods.watch(
                                                "brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone_country",
                                            ) ?? "US"
                                        }
                                        placeholder="1 (212) 313-2123"
                                        value={methods.watch("brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone")}
                                    />

                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_working_hours"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="Working Hours"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_contact_us_i2c_standard_working_hours"}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        Contact Center Working Hours:
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_head_office_address"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cTextarea
                                                label="Head Office Address"
                                                {...field}
                                                name="brand_info_common_brand_contact_us_i2c_standard_head_office_address"
                                                resize="none"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                                placeholder="456 Park Avenue, New York, NY 10022"
                                                rows={3}
                                            />
                                        )}
                                    />
                                    <ErrorMessage
                                        show={
                                            errors.brand_info_common_brand_contact_us_i2c_standard_head_office_address &&
                                                methods.formState.touchedFields.brand_info_common_brand_contact_us_i2c_standard_head_office_address
                                                ? true
                                                : false
                                        }
                                        message={errors.brand_info_common_brand_contact_us_i2c_standard_head_office_address?.message ?? "Invalid input"}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_postal_address"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cTextarea
                                                label="Postal Address"
                                                {...field}
                                                name="brand_info_common_brand_contact_us_i2c_standard_postal_address"
                                                resize="none"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                                placeholder="456 Park Avenue, New York, NY 10022"
                                                rows={3}
                                            />
                                        )}
                                    />
                                    <ErrorMessage
                                        show={
                                            errors.brand_info_common_brand_contact_us_i2c_standard_postal_address &&
                                                methods.formState.touchedFields.brand_info_common_brand_contact_us_i2c_standard_postal_address
                                                ? true
                                                : false
                                        }
                                        message={errors.brand_info_common_brand_contact_us_i2c_standard_postal_address?.message ?? "Invalid input"}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_facebook_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.facebook.com/username"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_contact_us_i2c_standard_facebook_link"}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        Facebook
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_instagram_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.instagram.com/username"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_contact_us_i2c_standard_instagram_link"}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        Instagram
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_twitter_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.twitter.com/username"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_contact_us_i2c_standard_twitter_link"}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        X (Previous Twitter)
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_youtube_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.youtube.com/username"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_contact_us_i2c_standard_youtube_link"}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        YouTube
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_contact_us_i2c_standard_linkedin_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.linkedin.com/username"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_contact_us_i2c_standard_linkedin_link"}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        LinkedIn
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                methods.watch("brand_info_common_brand_contact_us_feature_type") === "Use External URL" && (
                    <>
                        {fieldArray.map((field, index) => (
                            <div i2c-grid="12" >
                                <div i2c-grid="grid gap-sm">
                                    <div i2c-grid="12 6@md">
                                        <div className="single-field-wrapper">
                                            <Controller
                                                key={field.id}
                                                name={`brand_info_common_brand_contact_us_custom[${index}].page_name`}
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cInput
                                                        {...field}
                                                        className="single-input-field"
                                                        placeholder="Page Name"
                                                        onI2cInput={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(value);
                                                            handleValueChanges();
                                                        }}
                                                        size="large"
                                                        name={`brand_info_common_brand_contact_us_custom[${index}].page_name`}
                                                    >
                                                        <span slot="label" className="organize-tooltip">
                                                            <span className="custom-label">
                                                                {" "}
                                                                Page Name
                                                            </span>
                                                        </span>
                                                    </I2cInput>
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div i2c-grid="12 6@md">
                                        <div className="single-field-wrapper">
                                            <Controller
                                                key={field.id}
                                                name={`brand_info_common_brand_contact_us_custom[${index}].page_link`}
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cInput
                                                        {...field}
                                                        className="single-input-field"
                                                        placeholder="www.i2cinc.com/customer-care"
                                                        required
                                                        onI2cInput={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(value);
                                                            handleValueChanges();
                                                        }}
                                                        size="large"
                                                        name={`brand_info_common_brand_contact_us_custom[${index}].page_link`}
                                                        prefix_label="http://"
                                                    >
                                                        <span slot="label" className="organize-tooltip">
                                                            <span className="custom-label">
                                                                {" "}
                                                                Link
                                                            </span>
                                                        </span>
                                                        <I2cIcon slot="suffix" name="cs-linear-help-circle"></I2cIcon>
                                                    </I2cInput>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div i2c-grid="12 6@md">
                            <div className="single-field-wrapper">
                                <I2cButton variant="link color"
                                    onClick={handleAddAnother}>
                                    <I2cIcon slot="prefix" name="linear-add"></I2cIcon> Add Another
                                </I2cButton>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    );
};

export default ContactUsCommon;
